import { render, staticRenderFns } from "./whiteBookFile_enUS.vue?vue&type=template&id=2c5d1fe8&scoped=true"
import script from "./whiteBookFile_enUS.vue?vue&type=script&lang=js"
export * from "./whiteBookFile_enUS.vue?vue&type=script&lang=js"
import style0 from "./whiteBookFile_enUS.vue?vue&type=style&index=0&id=2c5d1fe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d1fe8",
  null
  
)

export default component.exports